import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {RouterModule} from '@angular/router';
import {SectionHeaderComponent} from '@lib-modules/section/components/section-header/section-header.component';
import {VideoSectionComponent} from '@lib-modules/section/components/video-section/video-section.component';
import {SharedSliderModule} from '@shared/modules/shared-slider/shared-slider.module';
import {LibCardsModule} from '@lib-modules/cards/lib-cards.module';
import {NewsSectionComponent} from '@lib-modules/section/components/news-section/news-section.component';
import {PickerModule} from '@lib-modules/picker/picker.module';
import {LibSliderModule} from '@lib-modules/slider/lib-slider.module';
import { FilterSectionComponent } from './components/filter-section/filter-section.component';
import { MatchSectionComponent } from './components/match-section/match-section.component';
import {ButtonsModule} from '@lib-modules/buttons/buttons.module';
import { EntityVideosSectionComponent } from './components/entity-videos-section/entity-videos-section.component';
import {SharedVideosModule} from '@shared/modules/shared-videos/shared-videos.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {LibAdsModule} from '@lib-modules/ads/lib-ads.module';
import { EntityHomeSectionComponent } from './components/entity-home-section/entity-home-section.component';
import { OverviewSectionComponent } from './components/overview-section/overview-section.component';
import { LibGamesModule } from '@components/games/lib-games.module';
import { LibTableModule } from '@lib-modules/table/lib-table.module';
import {LibBannersModule} from '@lib-modules/banners/lib-banners.module';
import { SpecialsSectionComponent } from './components/specials-section/specials-section.component';
import {SharedSpecialsModule} from '@shared/modules/shared-specials/shared-specials.module';
import { ContentCardListComponent } from '@lib-modules/section/components/content-card-list/content-card-list.component';
import {MatButtonModule} from '@angular/material/button';
import {SharedNewsModule} from '@shared/modules/shared-news/shared-news.module';
import {LibAdCampaignModule} from '@components/ad-campaign/lib-ad-campaign.module';
import {LibLazyImageModule} from '@components/image/modules/lazy-image/lib-lazy-image.module';
import { ShopSectionComponent } from './components/shop-section/shop-section.component';

@NgModule({
  declarations: [
    SectionHeaderComponent,
    VideoSectionComponent,
    NewsSectionComponent,
    FilterSectionComponent,
    MatchSectionComponent,
    EntityVideosSectionComponent,
    EntityHomeSectionComponent,
    OverviewSectionComponent,
    SpecialsSectionComponent,
    ContentCardListComponent,
    ShopSectionComponent
  ],
  exports: [
    SectionHeaderComponent,
    VideoSectionComponent,
    NewsSectionComponent,
    FilterSectionComponent,
    MatchSectionComponent,
    EntityVideosSectionComponent,
    EntityHomeSectionComponent,
    OverviewSectionComponent,
    SpecialsSectionComponent,
    ContentCardListComponent,
    ShopSectionComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    RouterModule,
    SharedSliderModule,
    LibCardsModule,
    PickerModule,
    LibSliderModule,
    ButtonsModule,
    SharedVideosModule,
    MatProgressSpinnerModule,
    LibAdsModule,
    LibGamesModule,
    LibTableModule,
    LibBannersModule,
    SharedSpecialsModule,
    MatButtonModule,
    SharedNewsModule,
    LibAdCampaignModule,
    LibLazyImageModule,
  ]
})
export class LibSectionModule { }
